<template>
  <div class="d-flex flex-row" v-on="!onlyRead ? { click: toggle } : null">
    <p
      class="mr-2 mb-0"
      :class="value ? 'custom-disable' : 'custom-enable'"
      style="font-size: 14px"
    >
      {{ leftLabel }}
    </p>
    <b-form-checkbox
      :checked="value"
      v-on:input="$emit('input', $event.target.value)"
      :disabled="onlyRead"
      size="sm"
      name="check-button"
      switch
    >
      <span :class="value ? 'custom-enable' : 'custom-disable'">{{
        rightLabel
      }}</span>
    </b-form-checkbox>
  </div>
</template>

<script>
export default {
  name: "CustomToggle",
  props: {
    leftLabel: String,
    rightLabel: String,
    onlyRead: Boolean,
    value: Boolean
  },
  methods: {
    toggle() {
      this.$emit("toggle");
    }
  }
};
</script>

<style scoped>
div >>> .custom-control-input ~ .custom-control-label::before {
  color: #fff;
  border-color: #0d6efd;
  background-color: #0d6efd;
}
div >>> .custom-control-input ~ .custom-control-label::after {
  background-color: #fff;
}
div >>> .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: lightgray;
  color: whitesmoke;
  border-color: whitesmoke;
}
div >>> .custom-control-input:disabled ~ .custom-control-label::after {
  background-color: lightslategrey;
}
.custom-disable {
  color: lightslategrey;
}
.custom-enable {
  color: #0d6efd;
}
</style>
